import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { TSeachedUser } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetUserMessages = async ({
  userId,
  limit,
  messageType,
  startMessageId,
  startMessageSentOn,
  messageEra
}: {
  userId: number;
  limit: number;
  messageType: string;
  startMessageId: number;
  startMessageSentOn: string;
  messageEra: string;
}): Promise<{
  data: {
    messages: {
      messageId: number;
      senderId: number;
      recipientId: number;
      message: string;
      sentOn: string;
      messageType: string;
    }[];
    userHasMoreMessages: boolean;
    searchedUser: TSeachedUser;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    messages: {
      messageId: number;
      senderId: number;
      recipientId: number;
      message: string;
      sentOn: string;
      messageType: string;
    }[];
    userHasMoreMessages: boolean;
    searchedUser: TSeachedUser;
  }>(`user/getUserMessages`, {
    userId,
    limit,
    messageType,
    startMessageId,
    startMessageSentOn,
    messageEra
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: {
        messages: reduce(() => data.messages, []),
        userHasMoreMessages: reduce(() => data.userHasMoreMessages, false),
        searchedUser: data.searchedUser
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        messages: [],
        userHasMoreMessages: false,
        searchedUser: {
          userID: -1,
          userGender: ""
        }
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        messages: [],
        userHasMoreMessages: false,
        searchedUser: {
          userID: -1,
          userGender: ""
        }
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
